import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from 'next-themes'
import { Toaster } from '@/components/ui'
import '@/styles/globals.scss'
import '@/i18n'
import { initializeFontScale } from '@/lib/fontScale'

// Import the generated route tree
import { routeTree } from './routeTree.gen'

// Create a QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

// Create a new router instance
const router = createRouter({ routeTree })
initializeFontScale()

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem
      disableTransitionOnChange
    >
      <QueryClientProvider client={queryClient}>
        <div className="antialiased bg-background">
          <RouterProvider router={router} />
        </div>
        <Toaster
          position="top-center"
          duration={2000}
          toastOptions={{
            unstyled: true,
            style: {
              width: '420px',
            },
          }}
        />
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
)

